"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCashDiscountSchema = exports.APosCashDiscountStatusSchema = exports.APosCashDiscountTypeSchema = void 0;
exports.calculateCashPrice = calculateCashPrice;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
// A cash discount lowers the Retail price when the customer pays by cash.
// Referenced per location as `retail.cashDiscountId`. The cash price is never
// stored — it is always derived from the current retail price, so every price
// change (bulk, auto, copy-from, manual) carries the cash price with it.
exports.APosCashDiscountTypeSchema = zod_1.z.enum(['percent', 'amount']);
// No dates: a cash discount is either on or off. `deleted` is the soft-delete tombstone.
exports.APosCashDiscountStatusSchema = zod_1.z.enum(['active', 'inactive', 'deleted']);
exports.APosCashDiscountSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    cashDiscountId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(150),
    description: zod_1.z.string().max(500).optional(),
    type: exports.APosCashDiscountTypeSchema,
    // percent: 0–100. amount: dollars off each unit.
    value: zod_1.z.number().nonnegative(),
    // true  = applies on top of promotions / manual / order discounts.
    // false = only applies to lines with no other discount (no double stacking).
    stackable: zod_1.z.boolean().default(true),
    status: exports.APosCashDiscountStatusSchema.default('active'),
}).merge(timestamps_schema_1.TimestampsSchema).refine((d) => d.type !== 'percent' || d.value <= 100, { message: 'Percentage cannot exceed 100', path: ['value'] });
/** Cash price for one unit. Never below zero, rounded to cents. */
function calculateCashPrice(price, discount) {
    if (!discount || !(price > 0))
        return Math.max(0, price || 0);
    const raw = discount.type === 'percent'
        ? price * (1 - Math.min(100, discount.value) / 100)
        : price - discount.value;
    return Math.max(0, Math.round(raw * 100) / 100);
}
//# sourceMappingURL=cash-discount.schema.js.map